import { Form } from "../Support/Form";
import { axios } from "../Support/axios";

export class Report extends Form {

    constructor(data = {}) {
        super({
            connection: 'mysql',
            display_limit: 25,
            show_data: true,
            show_totals: false,
            admin_only: false,
            active: true,
            middleware: [],
            fields: [],
            selects: [],
            joins: [],
        });

        this.connections = [];
        this.middleware = [];
        this.models = [];
        this.data_types = [];

        this.field_types = [
            { value: 'text', name: 'Text' },
            { value: 'number', name: 'Number' },
            { value: 'date', name: 'Date' },
            { value: 'time', name: 'Time' },
            { value: 'datetime', name: 'DateTime' },
            { value: 'select', name: 'Select' },
        ];

        this.join_types = [
            { value: 'inner_join', name: 'INNER' },
            { value: 'left_join', name: 'LEFT' },
            { value: 'right_join', name: 'RIGHT' },
        ];

        this.report_parameters = {};

        this.reports = false; // index report

        this.report_structure = false; // show report (fields)
        this.report_results = false; // render report (results)
    }

    reportsAvailable() {
        if (this.reports && this.reports.data) {
            return this.reports.data.length > 0;
        }

        return false;
    }

    index() {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get('/api/report', self.data)
                .then(response => {

                    this.reports = response.data;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                })
        });
    }

    all() {
        let self = this;
        let uri = this.api_prefix + '/report/all';

        return new Promise((resolve, reject) => {
            axios.get(uri)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

    showReport(id) {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get('/api/report/' + id, self.data)
                .then(response => {
                    self.report_structure = response.data.data;

                    resolve(true);
                }).catch(error => {
                reject(error);
            });
        });
    }

    hasRenderFields() {
        let self = this;

        if (self.report_structure) {
            self.report_structure.fields.forEach(function (field) {
                self.report_parameters[field.alias] = null;
            });

            return self.report_structure.fields.length > 0;
        }

        return false;
    }

    renderReport(id) {
        let self = this;

        self.resetFormMessages().then(result => {
            self.setFormUpdating();
        });

        return new Promise((resolve, reject) => {
            axios.post('/api/report/' + id, self.report_parameters)
                .then(response => {
                    self.report_results = response.data;

                    self.setFormUpdateComplete();

                    resolve(true);
                }).catch(error => {
                reject(error);
            });
        });
    }

    showManageReport(id) {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get('/api/report/manage/' + id, self.data)
                .then(response => {
                    self.data = response.data.data;

                    resolve(true);
                }).catch(error => {
                reject(error);
            });
        });
    }

    downloadReport(report) {
        let self = this;
        axios({
            url: '/api/report/' + report + '/export',
            method: 'post',
            data: Object.assign(report, self.params),
            headers: {
                'Accept': 'application/json'
            }
        }).then(response => response.data)
        .then(data => {
            window.open(data.uri, '_blank');

        }).catch(error => {
            console.error(error);
        });
    }

    submitReportManagerForm() {
        let self = this;

        self.resetFormMessages().then(result => {
            self.setFormUpdating();
        });

        return new Promise((resolve, reject) => {
            if (this.data.id) {
                axios.patch('/api/report/manage/' + this.data.id, self.data)
                    .then(response => {
                        this.data = response.data.data;

                        self.setSuccessMessage('Report Updated')
                        self.setFormUpdateComplete();

                        resolve(true);
                    })
                    .catch(error => {
                        self.setError(error);
                        reject(error);
                    })
            } else {
                axios.post('/api/report/manage', self.data)
                    .then(response => {
                        this.data = response.data.data;

                        self.setSuccessMessage('Report Created')
                        self.setFormUpdateComplete();

                        resolve(true);
                    })
                    .catch(error => {
                        self.setError(error);
                        reject(error);
                    })
            }
        });
    }

    loadSettings() {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get('/api/report/manage/settings', self.data)
                .then(response => {
                    self.connections = response.data.connections;
                    self.middleware = response.data.middleware;
                    self.models = response.data.models;
                    self.data_types = response.data.data_types;

                    resolve([
                        self.connections,
                        self.middleware,
                        self.models,
                        self.data_types
                    ]);
                }).catch(error => {
                reject(error);
            });
        });
    }

    connections() {
        let self = this;

        return new Promise((resolve, reject) => {
            self.request('/api/report/connection', 'get')
                .then(response => {
                    self.connections = response.data;

                    resolve(self.connections);
                }).catch(error => {
                reject(error);
            });
        });
    }

    middleware() {
        let self = this;

        return new Promise((resolve, reject) => {
            self.request('/api/report/middleware', 'get')
                .then(response => {
                    self.models = response.data;

                    resolve(self.models);
                }).catch(error => {
                reject(error);
            });
        });
    }

    models() {
        let self = this;

        return new Promise((resolve, reject) => {
            self.request('/api/report/model', 'get')
                .then(response => {
                    self.models = response.data;

                    resolve(self.models);
                }).catch(error => {
                reject(error);
            });
        });
    }

    dataTypes() {
        let self = this;

        return new Promise((resolve, reject) => {
            self.request('/api/report/data/type', 'get')
                .then(response => {
                    self.models = response.data;

                    resolve(self.models);
                }).catch(error => {
                reject(error);
            });
        });
    }

    hasMiddleware() {
        if (this.data.middleware) {
            return this.data.middleware.length > 0;
        }

        return false;
    }

    hasFields() {
        if (this.data.fields) {
            return this.data.fields.length > 0;
        }

        return false;
    }

    hasSelects() {
        if (this.data.selects) {
            return this.data.selects.length > 0;
        }

        return false;
    }

    hasJoins() {
        if (this.data.joins) {
            return this.data.joins.length > 0;
        }

        return false;
    }

    addMiddleware() {
        let self = this;

        return new Promise((resolve, reject) => {
            self.data.middleware.push({
                id: null,
                middleware: null,
                deleted_at: null
            });

            resolve();
        });
    }

    removeMiddleware(index) {
        let self = this;

        return new Promise((resolve, reject) => {
            self.data.middleware[index].deleted_at = this.getTimestamp();

            resolve();
        });
    }

    addField() {
        let self = this;

        return new Promise((resolve, reject) => {
            self.data.fields.push({
                id: null,
                label: null,
                type: 'text',
                model: null,
                alias: null,
                model_select_value: null,
                model_select_name: null,
                deleted_at: null
            });

            resolve();
        });
    }

    removeField(index) {
        let self = this;

        return new Promise((resolve, reject) => {
            self.data.fields[index].deleted_at = this.getTimestamp();

            resolve();
        });
    }


    addSelect() {
        let self = this;

        return new Promise((resolve, reject) => {
            self.data.selects.push({
                id: null,
                column: null,
                alias: null,
                type: this.data_types[0].value,
                column_order: self.data.selects ? self.data.selects.length + 1 : 1,
                deleted_at: null
            });

            resolve();
        });
    }

    removeSelect(index) {
        let self = this;

        return new Promise((resolve, reject) => {
            self.data.selects[index].deleted_at = this.getTimestamp();

            resolve();
        });
    }

    addJoin() {
        let self = this;

        return new Promise((resolve, reject) => {
            self.data.joins.push({
                id: null,
                type: 'inner_join',
                table: null,
                first: null,
                operator: null,
                second: null,
                deleted_at: null
            });

            resolve();
        });
    }

    removeJoin(index) {
        let self = this;

        return new Promise((resolve, reject) => {
            self.data.joins[index].deleted_at = this.getTimestamp();

            resolve();
        });
    }

    moveSelectUp(index) {
        let previousSelect = this.data.selects[index - 1];
        let select = this.data.selects[index];

        if (previousSelect && select) {
            this.data.selects[index - 1].column_order = previousSelect.column_order + 1;
            this.data.selects[index].column_order = select.column_order - 1;

            let element = this.data.selects[index];
            this.data.selects.splice(index, 1);
            this.data.selects.splice(index - 1, 0, element);
        }
    }

    /**
     * Move Report Select Down
     *
     * @param index
     */
    moveSelectDown(index) {
        let nextSelect = this.data.selects[index + 1];
        let select = this.data.selects[index];

        if (nextSelect && select) {
            this.data.selects[index + 1].column_order = nextSelect.column_order - 1;
            this.data.selects[index].column_order = select.column_order + 1;

            let element = this.data.selects[index];
            this.data.selects.splice(index, 1);
            this.data.selects.splice(index + 1, 0, element);

            return this.data.selects[index + 1];
        }
    }

    getTimestamp() {
        return new Date().toISOString().slice(0, 19).replace('T', ' ');
    }

}
